/** Utility function used for type-safe awaiting of Promises in MobX flows */
export function* awt<T>(promise: PromiseLike<T>): Generator<PromiseLike<T>, T, T> {
    return yield promise;
}

/** Coerces MobX flows to their runtime type */
export const asAsync = <Args extends unknown[], T>(fn: (...args: Args) => Generator<PromiseLike<any>, T, any>) =>
    fn as any as (...args: Args) => Promise<T>;
